import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { SERVICE_URLS, ITCIApplicationUpdateRequest, ITCIApplicationUpdateResponse } from "@tci/common";
import { Observable, Subject } from "rxjs";

export interface ITCIEndpointState {
    appId: string;
    status: string;
}

@Injectable()
export class BaseAppDetailSetEndpointService {
    private static instance: BaseAppDetailSetEndpointService = null;

    private status$: Subject<ITCIEndpointState> = new Subject();

    public static getInstance(http: Http) {
        if (!BaseAppDetailSetEndpointService.instance) {
            BaseAppDetailSetEndpointService.instance = new BaseAppDetailSetEndpointService(http);
        }
        return BaseAppDetailSetEndpointService.instance;
    }

    constructor(private http: Http) {

    }

    /**
     *
     * @param visibility public | private
     */
    public updateAppEndpointVisibility(appReq: ITCIApplicationUpdateRequest): Observable<ITCIApplicationUpdateResponse> {
        return this.http.post(`${SERVICE_URLS.APPS}/${appReq.appId}/endpoints`, appReq)
            .map((response: Response) => response.json());
    }

    public publishStatus(appId: string, status: string) {
        this.status$.next({ appId, status });
    }

    public getStatusSubject() {
        return this.status$;
    }
}
